import React, {useEffect, useState} from 'react'
import {Modal, Row, Col, ListGroup, ListGroupItem} from 'react-bootstrap'
import { useDispatch, useSelector , RootStateOrAny } from 'react-redux'
import { getSampleIDs, getTestPanelIDs } from '../../../redux-store/actions/protondxAdminActions'
import Alerts from '../../partials/Alerts'
import { Spinner } from 'react-bootstrap'
import SampleIdComponent from './SampleIdComponent'
import TestPanelComponent from './TestPanelComponent'
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';

const SampleIdTestPanel = (props) => {

    const {processing, success, error} = useSelector((state:RootStateOrAny)=>state.protondxAdminSampleIds)
    const {processing1, success1, error1} = useSelector((state:RootStateOrAny)=>state.protondxAdminTestPanelIds)

    // var {processing2, success2, error2} = useSelector((state : RootStateOrAny)=>state.protondxAdminUpdateSampleId)
    const dispatch = useDispatch()

    const [newSampleAdded, setNewSampleAdded] = useState(false)
    const [newPanelAdded, setNewPanelAdded] = useState(false)
    const [sampleArray, setSampleArray] = useState([])
    const [testPanelArray, setTestPanelArray] = useState([])

    useEffect(() => {
        async function getsampleIdsList(){
            await dispatch(getSampleIDs())
        }
        async function gettestpanelsList(){
            await dispatch(getTestPanelIDs())
        }
        getsampleIdsList()
        gettestpanelsList()
    }, [])

    useEffect(()=>{
        if(success){
          var tempArray = success.results.map(function(el){
                return {
                    _id: el._id.$oid,
                    sampleid: el.sampleid,
                    sampleenabled: el.sampleenabled
                }
            })
          setSampleArray(tempArray)
        }
    },[success])

    useEffect(()=>{
        if(success1){
          var tempArray = success1.results.map(function(el){
                return {
                    _id: el._id.$oid,
                    testpanelid: el.testpanelid,
                    testpanelenabled: el.testpanelenabled
                }
            })
          setTestPanelArray(tempArray)
        }
    },[success1])

    useEffect(()=>{
        if(newPanelAdded === true){
          setNewPanelAdded(false)
        }
    },[newPanelAdded])
    useEffect(()=>{
        if(newSampleAdded === true){
          setNewSampleAdded(false)
        }
    },[newSampleAdded])

    const updateSampleArray = (element, sample_id, enabled, operation)=>{
      if(operation === true){ //Edit mode
        var newSampleArray = sampleArray.map(function(el){
               if(el._id === element){
                 return {
                  _id: el._id,
                  sampleid: sample_id,
                  sampleenabled: enabled
                  }
               } else {
                 return el
              }
           })
          setSampleArray(newSampleArray)
          setNewSampleAdded(true)
      }else{ //delete mode
        var newSampleArray = sampleArray.filter(el => el._id !== element);
        setSampleArray(newSampleArray)
        setNewSampleAdded(true)
      }
    }

    const updateTPArray = (element, test_panel_id, enabled, operation)=>{
      if(operation === true){ //Edit mode
        var newTPArray = testPanelArray.map(function(el){
               if(el._id === element){
                 return {
                  _id: el._id,
                  testpanelid: test_panel_id,
                  testpanelenabled: enabled
                  }
               } else {
                 return el
              }
           })
          setTestPanelArray(newTPArray)
          setNewPanelAdded(true)
      }else{ //delete mode
        var newTPArray = testPanelArray.filter(el => el._id !== element);
        setTestPanelArray(newTPArray)
        setNewPanelAdded(true)
      }
    }

    return (
            <Modal
                {...props}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                    Configuration
                    </Modal.Title>
                </Modal.Header>
                    <Modal.Body>

                    <Tabs
                      defaultActiveKey="configkits"
                      id="uncontrolled-tab-example"
                      className="mb-3"
                    >
                    <Tab eventKey="configkits" title="Kits">
                    <div className='modal-body'>
                        <div className="parentInModal">
                            <div className="sampletestidsection">
                                <div>Sample ID</div>
                                <ListGroup>
                                { sampleArray.length > 0 ?
                                  sampleArray.map((item, index) => (
                                    <ListGroupItem>
                                      <SampleIdComponent key={item.sampleid} sampleid={item.sampleid} dbid={item._id} sampleenabled={item.sampleenabled} newSample={false} setNewSample={setNewSampleAdded} sampleArray={sampleArray} updateSampleArray={updateSampleArray}/>
                                    </ListGroupItem>
                                  ))
                                  :
                                  <ListGroupItem>
                                    <SampleIdComponent key="0" sampleid="" dbid="" sampleenabled={false} newSample={newSampleAdded} setNewSample={setNewSampleAdded} sampleArray={sampleArray} updateSampleArray={updateSampleArray}/>
                                  </ListGroupItem>
                                }
                                { sampleArray.length > 0 ?
                                  sampleArray.map((item, index) => (
                                    (index === sampleArray.length - 1) ?
                                    <ListGroupItem>
                                      <SampleIdComponent sampleid="" dbid="" sampleenabled={false} newSample={newSampleAdded} setNewSample={setNewSampleAdded} sampleArray={sampleArray} updateSampleArray={updateSampleArray}/>
                                    </ListGroupItem>
                                    : ""
                                  ))
                                  : ""
                                }
                                </ListGroup>
                              </div>

                              <div className="sampletestidsection">
                                <div>Test Panel Kit</div>
                                <ListGroup>
                                { testPanelArray.length > 0 ?
                                  testPanelArray.map((item, index) => (
                                    <ListGroupItem>
                                      <TestPanelComponent key={item.testpanelid} testpanelid={item.testpanelid} dbid={item._id} testpanelenabled={item.testpanelenabled} newTestPanel={false} setNewTestPanel={setNewPanelAdded} testPanelArray={testPanelArray}  updateTPArray={updateTPArray}/>
                                    </ListGroupItem>
                                  ))
                                  :
                                  <ListGroupItem>
                                    <TestPanelComponent key="0" testpanelid="" dbid="" testpanelenabled={false} newTestPanel={newPanelAdded} setNewTestPanel={setNewPanelAdded} testPanelArray={testPanelArray}  updateTPArray={updateTPArray}/>
                                  </ListGroupItem>
                                }
                                { testPanelArray.length > 0 ?
                                  testPanelArray.map((item, index) => (
                                    (index === testPanelArray.length - 1) ?
                                    <ListGroupItem>
                                      <TestPanelComponent testpanelid="" dbid="" testpanelenabled={false} newTestPanel={newPanelAdded} setNewTestPanel={setNewPanelAdded} testPanelArray={testPanelArray}  updateTPArray={updateTPArray}/>
                                    </ListGroupItem>
                                    : ""
                                  ))
                                  : ""
                                }
                                </ListGroup>
                              </div>
                              <div style={{marginTop:'10px'}}>
                                  {error && <Alerts type="danger" message={error} />}
                              </div>
                           </div> {/* <!-- end of parent section */}
                           <div style={{fontSize: "12px", justifyContent: "flex-end", float: "right"}}>
                           Checkbox enables/disables the kit id for the system
                           </div>
                        </div>
                        {
                            processing?
                            <div>Updating data...
                                <Spinner
                                    as="span"
                                    animation="grow"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                />
                            </div>
                            :
                            ( error ? <div style={{color: "red", fontWeight: "bold", marginLeft: "10px"}}>Error while updating data</div>
                            : "" )
                        }
                        </Tab>
                      </Tabs>
                    </Modal.Body>
            </Modal>
    )
}

export default SampleIdTestPanel
